import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';
import { textBold, colors } from 'styles';
import { breakpoint } from 'utils/mediaQueries';

const StyledGrid = styled(Grid)`
  text-align: right;
  padding: 1rem;
  p {
    margin: 0;
  }
  ${breakpoint.down('md')`
  text-align: center`}
`;
const Title = styled(Markdown)`
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.h6.fontSize}px`};
  line-height: 2rem;
  ${textBold}
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};`}
`;
const Text = styled(Markdown)`
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
  line-height: 2rem;
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.body2.fontSize}px`};`};
`;
const AddressBlock = ({ data }) => {
  return (
    <StyledGrid container direction={'column'}>
      <Title>{data.frontmatter.title}</Title>
      <Text>{data.rawMarkdownBody}</Text>
    </StyledGrid>
  );
};
export default AddressBlock;
